var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.4982 5.58206C16.1839 5.38409 15.7977 5.36658 15.4684 5.53409L14.3569 6.09526C13.9459 6.30237 13.6909 6.72115 13.6909 7.18714V11.5623C13.6909 12.0283 13.9459 12.4463 14.3569 12.6549L15.4677 13.2153C15.6184 13.293 15.7797 13.3303 15.9409 13.3303C16.1344 13.3303 16.3264 13.2755 16.4982 13.1681C16.8124 12.9709 17 12.629 17 12.2544V6.49653C17 6.12191 16.8124 5.78003 16.4982 5.58206Z",
    fill: "#009EF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.42882 15H5.08478C3.26826 15 2 13.7475 2 11.9543V6.79569C2 5.00178 3.26826 3.75 5.08478 3.75H9.42882C11.2453 3.75 12.5136 5.00178 12.5136 6.79569V11.9543C12.5136 13.7475 11.2453 15 9.42882 15Z",
    fill: "#009EF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoBlue);
export default __webpack_public_path__ + "static/media/video-blue.96b319a685c29d2153388f3dff480681.svg";
export { ForwardRef as ReactComponent };